import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="modal"
export default class extends Controller {
  static values = { selector: { type: String, default: '#modal-window' } }

  open(e) {
    $(this.selectorValue).modal('show')
  }

  close(e) {
    $(this.selectorValue).modal('hide')
  }

  submitEnd(e) {
    if (e.detail.success) this.close()
  }
}
